import React, { Component } from "react";

class VeteranUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M9.9,9.7c1.4-0.4,2.7-0.4,4.1,0c0-0.2,0-0.3,0-0.4c0-1.8,0-3.7,0-5.5c0-0.2,0.1-0.3,0.3-0.3c1.5,0,3.1,0,4.6,0
	c0.3,0,0.3,0.1,0.3,0.3c0,0.8,0,1.7,0,2.5c0,0.2-0.1,0.4-0.2,0.5c-0.9,1.3-1.8,2.5-2.7,3.8c-0.1,0.2-0.1,0.3,0.1,0.4
	c1.5,1.3,2.4,2.9,2.7,4.8c0.5,3.8-2.1,7.3-5.9,8c-3.9,0.7-7.7-1.8-8.5-5.7c-0.5-2.6,0.3-4.9,2.2-6.8c0.2-0.2,0.2-0.3,0.1-0.4
	C6.4,9.6,5.6,8.2,4.8,6.9C4.7,6.6,4.6,6.4,4.6,6.1c0-0.8,0-1.6,0-2.4c0-0.2,0.1-0.3,0.3-0.3c1.6,0,3.2,0,4.7,0
	c0.2,0,0.3,0.1,0.3,0.3c0,1.9,0,3.7,0,5.6C9.9,9.5,9.9,9.6,9.9,9.7z M16.7,16.7c0-2.5-2-4.8-4.8-4.7c-2.6,0-4.7,2.1-4.7,4.8
	c0,2.7,2.3,4.8,5,4.7C14.8,21.4,16.8,19.2,16.7,16.7z M17.3,2c1.2,0,2.5,0,3.7,0c0.3,0,0.3-0.1,0.3-0.3c0-0.4,0-0.8,0-1.3
	C21.4,0,21.4,0,21,0C15.1,0,9.2,0,3.4,0C3.2,0,3,0,2.8,0C2.6,0,2.6,0.1,2.6,0.3c0,0.4,0,0.9,0,1.3C2.6,2,2.6,2,3,2c3,0,6,0,9,0
	C13.8,2,15.6,2,17.3,2z M8.1,15.3c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.7,0.5,1.3,1,2,1.5c0.2,0.1,0.3,0.3,0.2,0.5
	c-0.3,0.8-0.5,1.6-0.8,2.5c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2-0.1c0.7-0.5,1.4-1,2.1-1.5c0.2-0.1,0.3-0.1,0.5,0
	c0.7,0.5,1.4,1,2.1,1.5c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0-0.2,0-0.3c-0.3-0.8-0.5-1.6-0.8-2.5c-0.1-0.2,0-0.3,0.2-0.5
	c0.7-0.5,1.4-1,2-1.5c0.1-0.1,0.1-0.2,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.9,0-1.7,0-2.6,0c-0.2,0-0.3-0.1-0.4-0.3
	c-0.3-0.8-0.5-1.6-0.8-2.4c0-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.3,0.8-0.5,1.6-0.8,2.4c-0.1,0.2-0.2,0.3-0.5,0.3
	c-0.4,0-0.8,0-1.2,0C8.9,15.3,8.5,15.3,8.1,15.3z"
        />
      </svg>
    );
  }
}

export default VeteranUpSVG;



// WEBPACK FOOTER //
// ./src/svg/VeteranUpSVG.jsx